import React from "react";

import { cn } from "../cn";

export function Notice({ icon, title, className, children, ...props }: React.ComponentProps<"div"> & { icon?: React.ReactNode; title?: React.ReactNode }) {
  return (
    <div data-slot="notice" className={cn("tw-flex tw-items-start tw-gap-3 tw-rounded-lg tw-border tw-border-solid tw-border-border tw-bg-accent tw-p-4 tw-text-sm", className)} {...props}>
      {icon ? (
        <span data-slot="notice-icon" aria-hidden className="tw-mt-0.5 tw-shrink-0 tw-text-foreground">
          {icon}
        </span>
      ) : null}
      <div className="tw-flex tw-flex-col tw-gap-1">
        {title ? <p className="tw-m-0 tw-font-medium tw-text-foreground">{title}</p> : null}
        <div className="tw-text-xs tw-font-medium tw-leading-4 tw-tracking-normal tw-text-foreground">{children}</div>
      </div>
    </div>
  );
}
